/* =====================================================================
 * StructuredData — JSON-LD 구조화 데이터
 *
 * 검색엔진에 사이트·조직·앱 정보를 명시적으로 전달합니다.
 * 전역(Organization + WebSite)과 라우트별(SoftwareApplication) 스키마를 지원합니다.
 * ===================================================================== */

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, DEFAULT_OG_IMAGE } from './routeConfig';

function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export const GlobalStructuredData: React.FC = () => (
  <>
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'AskYourAI',
        url: SITE_URL,
        logo: `${SITE_URL}/agent_logo.png`,
        sameAs: [],
      }}
    />
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'AskYourAI',
        url: SITE_URL,
        description:
          'AI 에이전트와 대화하고, 문서를 작성하고, 이미지를 생성하세요. 팀 협업을 위한 올인원 AI 워크스페이스.',
        inLanguage: ['ko', 'en', 'ja', 'zh-Hans', 'zh-Hant'],
      }}
    />
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'WebApplication',
        name: 'AskYourAI',
        url: SITE_URL,
        applicationCategory: 'ProductivityApplication',
        operatingSystem: 'Web',
        image: DEFAULT_OG_IMAGE,
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD',
          description: 'Free tier available',
        },
      }}
    />
  </>
);
